// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OFEe","messages":"styles_messages__2wBmH"};